import React, { useState, useEffect } from "react";
import {
  ButtonToolbar,
  ToggleButtonGroup,
  ToggleButton,
  Form,
} from "react-bootstrap";
import PropTypes from "prop-types";
import { useAuth } from "../../components/AuthContext/AuthContext";

const ToggleButtons = ({
  field,
  toggleValueProp = "",
  genderIdentityProp = "",
  setFieldValue,
  noLabel = false,
  errors = {},
  touched = {},
  type,
}) => {
  const [toggleValue, setToggleValue] = useState(toggleValueProp);
  const [genderIdentity, setGenderIdentity] = useState(genderIdentityProp);
  const auth = useAuth();

  // Get default values for unit fields
  const getDefaultValue = () => {
    switch (field.name) {
      case "units":
        return "metric";
      case "heightUnits":
        return "metric";
      case "weightUnits":
        return "metric";
      default:
        return "";
    }
  };

useEffect(() => {
  const isUnitField = [
    "units",
    "heightUnits",
    "weightUnits",
  ].includes(field.name);

  if (isUnitField) {
    setToggleValue(toggleValueProp || field?.value || "metric");
  } else {
    setToggleValue(toggleValueProp || "");
  }
}, [toggleValueProp, field?.value, field?.name]);


  useEffect(() => {
    setGenderIdentity(genderIdentityProp || "");
  }, [genderIdentityProp]);

  if (!field?.options?.length) {
    return <div>No options available</div>;
  }

  const handleOptionClick = (optionValue) => {
    if (field.name === "units") {
      handleUnitChange(optionValue);
    } else if (
      field.name === "sex" ||
      field.name === "heightUnits" ||
      field.name === "weightUnits" ||
      field.name === "ispregnant" ||
      field.name === "had_unprotected_sex" ||
      field.name === "sti_symptoms" ||
      field.name === "potential_sti_exposure"
    ) {
      handleValueChange(optionValue);
    } else {
      handleGenderChange(optionValue);
    }
  };

  const handleUnitChange = (newUnit) => {
    auth.setToggled(newUnit !== toggleValueProp);
    auth.setUnitType({
      prevUnit: auth.unitType?.currentUnit || toggleValue || "metric",
      currentUnit: newUnit,
    });
    handleValueChange(newUnit);
  };

  const handleValueChange = (value) => {
    setToggleValue(value);
    setFieldValue(field.name, value);
  };

  const handleGenderChange = (value) => {
    setGenderIdentity(value);
    setFieldValue(field.name, value);
  };

  const renderLabel = () => {
    if (noLabel) return null;

    return (
       field.label && (
          <Form.Label className="labels" htmlFor={field?.name}>
            {field.label}
            {field.required && <span className="required"></span>}
          </Form.Label>
        )
    );
  };

  const getButtonVariant = (optionValue) => {
    const isUnitField =
      field.name === "sex" ||
      field.name === "units" ||
      field.name === "heightUnits" ||
      field.name === "weightUnits" ||
      field.name === "ispregnant" ||
      field.name === "had_unprotected_sex" ||
      field.name === "sti_symptoms" ||
      field.name === "potential_sti_exposure";

    const isSelected = isUnitField
      ? toggleValue === optionValue
      : genderIdentity === optionValue;

    return isSelected ? "primary" : "secondary";
  };

  return (
    <Form.Group>
      {renderLabel()}
      <ButtonToolbar>
        <ToggleButtonGroup
          type="radio"
          name={field.name}
          aria-label={field?.name}
        >
          {field.options.map((option) => (
            <ToggleButton
              key={`toggle-${option.value}`}
              disabled={field?.disabled}
              type={type}
              value={option.value}
              onClick={() => handleOptionClick(option.value)}
              variant={getButtonVariant(option.value)}
            >
              {option.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </ButtonToolbar>
      {errors[field.name] && touched[field.name] && (
        <div className="invalid-feedback d-block">{errors[field.name]}</div>
      )}
    </Form.Group>
  );
};

ToggleButtons.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
  noLabel: PropTypes.bool,
  toggleValueProp: PropTypes.string,
  genderIdentityProp: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.object,
  touched: PropTypes.object,
  type: PropTypes.string,
};

export default ToggleButtons;
